import styled from "styled-components";
import DatabaseHelpCard from "metabase/containers/DatabaseHelpCard";

export const HelpCard = styled(DatabaseHelpCard)`
  max-width: 21rem;
  margin-top: 1.25rem;
  margin-left: 6.5rem;
`;
